import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {BotatoChatManagerService, DelayedRenderedMessageComponent} from 'botato-angular-lib';
import {QuizResponseItemData} from '../../type/QuizResponseItemData';
import {SingleTextChoiceQuiz} from './SingleTextChoiceQuiz';
import {ResponseItemDataTextService} from '../../../response-item-data-text.service';
import {QuizQuestionResponseItemDataText} from '../../type/QuizQuestionResponseItemDataText';
import {DeactivateMessageService} from '../../../deactivate-message.service';
import {Subscription} from 'rxjs';
import {SingleTextChoiceQuizUpdateAnswer} from './SingleTextChoiceQuizUpdateAnswer';
import {QuizQuestion} from '../../type/QuizQuestion';

@Component({
    selector: 'mm-single-text-choice-quiz',
    templateUrl: './single-text-choice-quiz.component.html',
    standalone: false
})
export class SingleTextChoiceQuizComponent extends DelayedRenderedMessageComponent implements OnInit, OnDestroy {

    public static TYPE = 'SingleTextChoice';
    public static UPDATE_TYPE = 'updateSingleTextChoiceQuiz';

    public responseItemData!: QuizResponseItemData<SingleTextChoiceQuiz, QuizQuestionResponseItemDataText, SingleTextChoiceQuizUpdateAnswer>;
    public question!: QuizQuestion;
    public answers!: { id: number; letter: string; text: string; isCorrect: boolean; }[];
    public quizNumber!: string;
    public isDeactivated: boolean | undefined;
    public updatedMessage = false;
    public sourceUrl: string | undefined;
    public sourceLabel: string | undefined;
    public questionTranslationId: string | undefined;
    public learningPackageTranslationId: string | undefined;
    private subscription: Subscription | undefined;
    public shouldShowMessage: boolean = false;

    constructor(private botatoChatManagerService: BotatoChatManagerService,
                private responseItemDataTextService: ResponseItemDataTextService,
                private deactivateMessageService: DeactivateMessageService,
                private changeDetectorRef: ChangeDetectorRef) {
        super();
    }


    public ngOnDestroy(): void {
        if (this.subscription !== undefined) {
            this.subscription.unsubscribe();
        }
    }

    public ngOnInit(): void {
        if (this.message.type === SingleTextChoiceQuizComponent.TYPE) {
            this.shouldShowMessage = true;
            this.updatedMessage = this.isMessageUpdated();
            if (this.updatedMessage) {
                this.createMessageUpdateData();
            } else {
                this.subscription = this.deactivateMessageService.deactivateOldCustomMessage(this.message);

                this.isDeactivated = this.message.data.deactivated !== undefined ? this.message.data.deactivated : false;

                this.createMessageData();
            }

        }

        if (this.message.type === SingleTextChoiceQuizComponent.UPDATE_TYPE) {
            this.subscription = this.deactivateMessageService.setUpdateOfLastMessage(this.message.data, this.changeDetectorRef);
        }
    }

    public getLetterFromAlphabet(index: number): string {
        return String.fromCharCode(65 + index);
    }

    public sendAnswer(answer: string): void {
        void this.botatoChatManagerService.sendUserMessage(answer, 'quickreply');
    }

    public isMessageUpdated(): boolean {

        const updateMessage = this.message.data.updateMessage;
        return updateMessage?.type === SingleTextChoiceQuizComponent.UPDATE_TYPE && updateMessage.responseItemData !== undefined;
    }

    public mediaLoaded(): void {
        this.componentRenderingCompleted();
    }

    private createMessageData(): void {

        this.responseItemData = this.message.data.responseItemData;
        this.question = this.responseItemData.quiz.quiz;
        this.quizNumber = this.responseItemData.learningSessionData.quizNumber;
        this.answers = this.responseItemData.quiz.answers.map((answer, index: number) => {
            return {
                id: answer.id,
                letter: this.getLetterFromAlphabet(index),
                text: this.responseItemDataTextService.replaceText(answer.answerText),
                isCorrect: answer.isCorrectAnswer
            };
        });
    }

    private createMessageUpdateData(): void {

        this.responseItemData = this.message.data.updateMessage.responseItemData;
        const quizAnswerData = this.responseItemData.quizAnswerData!;
        this.question = quizAnswerData.quiz;
        this.quizNumber = quizAnswerData.quizNumber;
        this.sourceUrl = quizAnswerData.sourceUrl;
        this.sourceLabel = quizAnswerData.sourceLabel;
        this.questionTranslationId = quizAnswerData.id;
        this.learningPackageTranslationId = this.responseItemData.learningPackageTranslationId;
        this.answers = quizAnswerData.answers.map((answer, index: number) => {
            return {
                id: answer.id,
                letter: this.getLetterFromAlphabet(index),
                text: this.responseItemDataTextService.replaceText(answer.answerText),
                isCorrect: answer.isCorrectAnswer
            };
        });
    }

    public override onAnyMessageSent(): void {
        if (this.isDeactivated !== true) {

            this.message.data.deactivated = true;
        }
    }
}
